const endpoints = {
  // auth
  ADMIN_LOGIN: "/admin/login",
  ADMIN_LOGOUT: "/admin/logout",
  ADMIN_ME: "/admin/me",
  ADMIN_SEND_OTP: "/admin/send-otp",
  ADMIN_CHANGE_PASSWORD: "/admin/change-password",
  ADMIN_REFRESH_TOKEN: "/admin/refresh-token",
  ADMIN_COMPLETE_PROFILE: "/admin/complete-profile",

  // dashboard
  ADMIN_STATS: "/admin/stats",
  ADMIN_S3_CORS_HEALTH: "/admin/health/s3-cors",

  // category
  ADMIN_CATEGORIES: "/admin/categories",
  ADMIN_CATEGORIES_UPLOAD_URL: "/admin/categories/upload-url",
  ADMIN_SUBCATEGORIES: "/admin/subcategories",

  // prescriptions
  ADMIN_PRESCRIPTIONS: "/admin/prescriptions",
  ADMIN_PENDING_PRESCRIPTIONS: "/admin/prescriptions/pending",
  ADMIN_ACCEPT_MULTIPLE_PRESCRIPTIONS: "/admin/prescriptions/accept-multiple",
  ADMIN_ACCEPT_PRESCRIPTIONS_FOR_MATCH_REQUEST: "/admin/prescriptions/accept-for-match-request",
  ADMIN_REJECT_MULTIPLE_PRESCRIPTIONS: "/admin/prescriptions/reject-multiple",

  // bids / dashboard lists
  ADMIN_BID_LOG: "/admin/bid-log",
  ADMIN_BID_LOG_MARK_ADMIN_VIEWED: (id) => `/admin/bid-log/${encodeURIComponent(id)}/mark-admin-viewed`,
  ADMIN_BID_LOG_COMPLETE_TREATMENT: (id) => `/admin/bid-log/${id}/complete-treatment`,
  ADMIN_CONVERSATIONS: "/admin/conversations",
  ADMIN_CONVERSATION_BY_ID: (id) => `/admin/conversations/${id}`,
  ADMIN_CONVERSATION_PUSH_MESSAGE: (id) => `/admin/conversations/${id}/messages`,
  ADMIN_SUPPORT_INBOX: "/admin/support/inbox",
  adminSupportHistory: (patientId) => `/admin/support/history/${encodeURIComponent(patientId)}`,
  ADMIN_APPOINTMENT_APPROVE: (id) => `/admin/appointments/${id}/approve`,
  ADMIN_APPOINTMENT_PROPOSE_RESCHEDULE: (id) => `/admin/appointments/${id}/propose-reschedule`,
  ADMIN_BID_LOG_BOOKING_SLOTS: (bidLogId) => `/admin/bid-log/${encodeURIComponent(bidLogId)}/booking-slots`,
  ADMIN_PATIENTS: "/admin/patients",
  adminPatientById: (id) => `/admin/patients/${id}`,
  adminPatientAccept: (id) => `/admin/patients/${id}/accept`,
  adminPatientReject: (id) => `/admin/patients/${id}/reject`,
  adminPatientDelete: (id) => `/admin/patients/${id}`,
  ADMIN_DOCTORS_LIST: "/admin/doctors/list",
  ADMIN_HOSPITALS_LIST: "/admin/hospitals/list",
  ADMIN_PROVIDERS: "/admin/providers",
  ADMIN_DOCTORS_PENDING: "/admin/doctors/pending",
  ADMIN_HOSPITALS_PENDING: "/admin/hospitals/pending",
  ADMIN_NOTIFICATIONS: "/admin/notifications",
  ADMIN_NOTIFICATIONS_EXPIRING_SOON: "/admin/notifications/expiring-soon",
  ADMIN_APPROVAL_SUMMARY: "/admin/approval-summary",
  ADMIN_SEARCH: "/admin/search",
  ADMIN_GEOCODE: "/admin/geocode",
  ADMIN_REVERSE_GEOCODE: "/admin/reverse-geocode",

  ADMIN_PLATFORM_SETTINGS: "/admin/platform-settings",
  ADMIN_PLATFORM_BROADCAST: "/admin/platform-settings/broadcast",
  ADMIN_PLATFORM_TEST_EMAIL: "/admin/platform-settings/test-email",
  ADMIN_AUDIT_LOGS: "/admin/audit-logs",
  ADMIN_GALLERY_OBJECTS: "/admin/gallery/objects",
  ADMIN_GALLERY_OBJECTS_DELETE_ALL: "/admin/gallery/objects/all",

  ADMIN_COMPLIANCE_ANALYTICS: "/admin/compliance/analytics",
  ADMIN_COMPLIANCE_ANALYTICS_EVENTS: "/admin/compliance/analytics/events",
  ADMIN_COMPLIANCE_DISPUTES: "/admin/compliance/disputes",
  ADMIN_COMPLIANCE_DISPUTE_BY_ID: (id) => `/admin/compliance/disputes/${id}`,
  ADMIN_COMPLIANCE_REFUNDS: "/admin/compliance/refunds",
  ADMIN_COMPLIANCE_REFUND_BY_ID: (id) => `/admin/compliance/refunds/${id}`,

  // helper urls
  adminPrescriptionById: (id) => `/admin/prescriptions/${id}`,
  adminPrescriptionDownload: (id) => `/admin/prescriptions/${id}/download`,
  adminAcceptPrescription: (id) => `/admin/prescriptions/${id}/accept`,
  adminRejectPrescription: (id) => `/admin/prescriptions/${id}/reject`,

  adminDoctorById: (id) => `/admin/doctors/${id}`,
  adminDoctorAvailability: (id) => `/admin/doctors/${id}/availability`,
  adminDoctorDownloadDocument: (id, type) => `/admin/doctors/${id}/download-document?type=${encodeURIComponent(type)}`,
  adminDoctorApprove: (id) => `/admin/doctors/${id}/approve`,
  adminDoctorReject: (id) => `/admin/doctors/${id}/reject`,
  ADMIN_DOCTORS_PENDING_DEGREE_EDITS: "/admin/doctors/pending-degree-edits",
  adminDoctorDegreesApprove: (id) => `/admin/doctors/${id}/degrees/approve`,
  adminDoctorDegreesReject: (id) => `/admin/doctors/${id}/degrees/reject`,
  adminDoctorRating: (id) => `/admin/doctors/${id}/rating`,

  adminHospitalById: (id) => `/admin/hospitals/${id}`,
  adminHospitalApprove: (id) => `/admin/hospitals/${id}/approve`,
  adminHospitalReject: (id) => `/admin/hospitals/${id}/reject`,
  adminHospitalRating: (id) => `/admin/hospitals/${id}/rating`,
  adminDoctorRestrict: (id) => `/admin/doctors/${id}/restrict`,
  adminDoctorUnrestrict: (id) => `/admin/doctors/${id}/unrestrict`,
  adminHospitalRestrict: (id) => `/admin/hospitals/${id}/restrict`,
  adminHospitalUnrestrict: (id) => `/admin/hospitals/${id}/unrestrict`,
  adminDoctorDelete: (id) => `/admin/doctors/${id}`,
  adminHospitalDelete: (id) => `/admin/hospitals/${id}`,
};

export default endpoints;
